var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAddShape = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40.966,
  height: 37.958,
  fill: "currentColor",
  stroke: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Add Shape"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 65",
  d: "M37.445 19.963V4.309a3.9 3.9 0 0 0-1.44-2.569 7.119 7.119 0 0 0-3.531-.671H6.119s-2.747-.3-4 .671-1.007 3.21-1.007 3.21v24.231s-.362 1.766.454 2.627 2.811.817 2.811.817h22",
  fill: "none",
  stroke: "current",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 69",
  d: "M5.03 4.637h28.262v8.432H12.504V29.01H5.03Z",
  fill: "#fff",
  stroke: "current"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 70",
  d: "M17.391 16.289h7.825v7.538h-8.2v-8.2",
  fill: "#fff",
  stroke: "current"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon metro-plus",
  d: "M40.395 27.543h-5.438v-5.727a.566.566 0 0 0-.571-.521h-2a.521.521 0 0 0-.521.521v5.727h-5.726a.521.521 0 0 0-.521.521v2c0 .288.233.385.521.385h5.728v6.988a.521.521 0 0 0 .521.521H34.5a.47.47 0 0 0 .457-.521v-6.985h5.53c.288 0 .48-.1.48-.385v-2a.566.566 0 0 0-.572-.524Z",
  fill: "current"
}))));
export default SvgAddShape;